module.exports = __webpack_public_path__ + "img/max-max.3d2c4517.svg";